import { Home, ShoppingBag, Clock, User, ShoppingCart } from "lucide-react";
import { NavLink } from "@/components/NavLink";
import { cn } from "@/lib/utils";
import { useLanguage } from "@/contexts/LanguageContext";
import { useCart } from "@/contexts/CartContext";
import { Badge } from "@/components/ui/badge";

export const BottomNav = () => {
  const { t } = useLanguage();
  const { getTotalItems } = useCart();
  
  const totalItems = getTotalItems();
  
  const navItems = [
    { to: "/", icon: Home, label: t.main },
    { to: "/food", icon: ShoppingBag, label: t.food },
    { to: "/cart", icon: ShoppingCart, label: t.cart, badge: totalItems },
    { to: "/history", icon: Clock, label: t.history },
    { to: "/profile", icon: User, label: t.profile },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 border-t border-border/50 ios-glass">
      <div className="mx-auto flex h-16 max-w-screen-lg items-center justify-around px-2 pb-safe">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end
            className="relative flex flex-col items-center gap-1 px-3 py-2 text-muted-foreground"
            activeClassName="text-primary"
          >
            {({ isActive }) => (
              <>
                <div className="relative" data-cart-icon={item.to === "/cart" ? "true" : undefined}>
                  <item.icon className={cn("h-6 w-6", isActive && "text-primary")} />
                  {item.badge && item.badge > 0 && (
                    <Badge className="absolute -right-2 -top-2 h-4 min-w-4 rounded-full p-0 flex items-center justify-center text-[10px]">
                      {item.badge}
                    </Badge>
                  )}
                </div>
                <span className={cn("text-[10px] font-medium", isActive && "text-primary")}>{item.label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
};
